<lla-input
  class="w-full"
  type="google-places"
  [controlName]="controlName"
  [label]="label"
  (googlePlaceAddressChanged)="handleAddressChange($event)"
  [loading]="loading"
  size="small"
></lla-input>

<img class="mt-sm" src="assets/images/Powered_by_google.svg" />
